import type { Color } from 'theme/theme';
import { getStaticImageSrc } from 'utils/getImageSrc';

import type { IconName } from './IconName';
import { MaskImageIcon } from './MaskImageIcon';

export type IconProps = {
  name: IconName;
  size: number;
  opacity?: number;
  colorName?: Color;
  qaId?: string;
};

export function Icon({ name, size, opacity, colorName, qaId }: IconProps) {
  if (name === 'idealist-logo') {
    return (
      <img
        src={getStaticImageSrc('logos/logo-mark.webp')}
        alt="Idealist Logo Icon"
        width={size}
        height={size}
        style={{ opacity }}
        data-qa-id={qaId}
      />
    );
  }

  return (
    <MaskImageIcon
      src={getStaticImageSrc(`icons/normalized/${name}.svg`)}
      size={size}
      opacity={opacity}
      colorName={colorName}
      qaId={qaId}
      alt={`${name} icon`}
    />
  );
}
